<template>
    <div>
        <div class="title">
            Active Hours Form
        </div>
        <v-card>
            <div class="card-container">
                <div class="clock-container">
                    <span>Start Time :</span>
                    <v-time-picker
                        v-model="startTime"
                        use-seconds
                        format="24hr"
                    />
                </div>
                <div class="clock-container">
                    <span>End Time :</span>
                    <v-time-picker
                        v-model="endTime"
                        use-seconds
                        format="24hr"
                    />
                </div>
            </div>
            <v-switch
                v-model="enabled"
                class="form-field"
                :label="`Enabled: ${enabled.toString()}`"
            />
            <div class="text-center">
                <v-btn class="edit-btn" @click="createNewActiveHour">
                    Create Active Hour
                </v-btn>
            </div>
        </v-card>
        <alert :show-alert="showAlert" :message="alertMessage" :type="alertType" />
    </div>
</template>

<script>
    import activeHoursService from '@/services/active-hours-service'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { Alert },
        data() {
            return {
                startTime: null,
                endTime: null,
                enabled: false,
                showAlert: false,
                alertMessage: '',
                alertType: 'error'
            }
        },
        watch: {
            showAlert: {
                handler(newval) {
                    if (newval) {
                        setTimeout(() => { this.showAlert = false }, 3000)
                    }
                }
            }
        },
        methods: {
            createNewActiveHour() {
                const activeHour = {
                    startTime: this.startTime,
                    endTime: this.endTime,
                    enabled: this.enabled
                }
                activeHoursService.createActiveHour(activeHour).then((resp) => {
                    this.setAlert('Active Hours Entry Created', 'success')
                    setTimeout(() => {
                        this.$router.push('/active-hours')
                    }, 1000)
                }).catch(error => {
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.alertMessage = message
                this.alertType = type
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    padding: 15px;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

.clock-container {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 5px;
    width: 99%;
}

</style>
